import { render, staticRenderFns } from "./LeadFlowListFilters.vue?vue&type=template&id=dff2f480&"
import script from "./LeadFlowListFilters.vue?vue&type=script&lang=js&"
export * from "./LeadFlowListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports